import { createSelector } from 'reselect';
import MultiplePredesSummaryColumns from '../../containers/MultiplePredesSummaryColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.MULTIPLE_PREDES_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.MULTIPLE_PREDES_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.MULTIPLE_PREDES_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, MultiplePredesSummaryColumns);
